import cn from 'classnames';
import { Skeleton } from '@/common/base/skeleton';

export const columnWidth = ['w-[32%] pl-4', 'w-[15%] pl-[30px]', 'w-[13%]', 'w-[13%] pr-4'];
export const SkeletonItem = () => {
  return (
    <div className="py-3 h-[76px] flex gap-[10px]">
      <table className="w-full caption-bottom text-sm border-none table-fixed overflow-x-hidden">
        <tr>
          <td className={cn(columnWidth[0], 'px-2')}>
            <div className="flex gap-[10px] pr-3">
              <Skeleton className="size-[14px]  rounded-[2px] shrink-0" />
              <Skeleton className="size-[14px]  rounded-[2px] w-full shrink-0" />
            </div>
          </td>
          <td className={cn(columnWidth[1], 'px-3')}>
            <Skeleton className="size-[14px]  rounded-[2px] w-full shrink-0" />
          </td>
          <td className={cn(columnWidth[2], 'px-3')}>
            <Skeleton className="size-[14px]  rounded-[2px] w-full shrink-0" />
          </td>
          <td className={cn(columnWidth[3], 'px-3')}>
            <Skeleton className="size-[14px]  rounded-[2px] w-full shrink-0" />
          </td>
        </tr>
        <tr>
          <td colSpan={2} className={cn(columnWidth[0], 'px-3 pt-2')}>
            <div className="flex gap-[10px] pr-3 pl-[10px]">
              <Skeleton className="size-[14px]  rounded-[2px] shrink-0  opacity-0" />
              <Skeleton className="size-[14px]  rounded-[2px] w-full shrink-0" />
            </div>
          </td>
          <td className={cn(columnWidth[2], 'px-3 pt-2')}></td>
          <td className={cn(columnWidth[3], 'px-3 pt-2')}></td>
        </tr>
        <tr className="">
          <td colSpan={2} className={cn(columnWidth[0], 'px-3 pt-2')}>
            <div className="flex gap-[10px] pr-3 pl-[10px]">
              <Skeleton className="size-[14px]  rounded-[2px] shrink-0  opacity-0" />
              <Skeleton className="size-[14px]  rounded-[2px] w-[60%] shrink-0" />
            </div>
          </td>
          <td className={cn(columnWidth[2], 'px-3')}></td>
          <td className={cn(columnWidth[3], 'px-3')}></td>
        </tr>
      </table>
    </div>
  );
};
